export const TRACK_CAT = 'Footer';
